import type { PatientProfileTab, PatientSubNavIconMap } from './types';

export const PP_SUBNAV: PatientProfileTab[] = [
  'Profile',
  'Communications',
  'Insurance',
  'Forms',
  'Treatments',
  'Invisalign',
];

export const PP_SUBNAV_ICONS: PatientSubNavIconMap = {
  Profile: 'team',
  Communications: 'chat',
  Insurance: 'shield',
  Forms: 'doc',
  Treatments: 'flask',
  Invisalign: 'plus',
};

/** Canonical mock patient IDs with full profile tab bundles. */
export const PP_MOCK_PATIENT_IDS = [
  'amara-reza',
  'james-chen',
  'sara-malik',
  'tom-rivera',
  'p001', // Orville Allison — the Invisalign patient (amendment 34 §4).
] as const;

/** Default mock bundle when route id is a directory patient. */
export const PP_DEFAULT_MOCK_PATIENT_ID = PP_MOCK_PATIENT_IDS[0];

export const PP_CONSENTS = [
  { label: 'Clinical', on: true, req: true },
  { label: 'Personalization', on: true, req: false },
  { label: 'Family linking', on: true, req: false },
  { label: 'Marketing', on: false, req: false },
] as const;
